import { NotificationDetails } from '@notification/components'
import { paths } from '@organization/router'
import { TitleSection } from '@shared/components'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router-dom'

export const NotificationsDetailsPage = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  if (!id) return <Navigate to={paths.applications} />

  return (
    <>
      <TitleSection title={t('menu.notifications')} />

      <NotificationDetails id={Number(id)} />
    </>
  )
}
